/*
  assets/vs-pdp-bundle.js  (15-Sep-2026 speed pass)

  WHAT THIS IS
  The product page used to ship ~150KB of JavaScript INLINE, inside 21 vs-* snippets
  rendered from snippets/vitalsleep-variants.liquid. That code was downloaded again
  with every page view (HTML is not cached) and parsed in the middle of the page.
  It now lives here, one cached file loaded with defer.

  HOW IT RUNS (keeps the old timing on purpose)
  - Each snippet still renders a one-line <script> "stub" in the same place its code
    used to be. The stub pushes [snippet name, settings] onto window.__VSB. Liquid
    values (section id, product title, variant list, on/off flags) are in the stub,
    so Liquid gates and render params still work exactly as before.
  - The top of vitalsleep-variants.liquid registers ONE DOMContentLoaded listener, in
    the same spot the first inline script used to run. When it fires it calls
    window.__VSBRUN (defined below), which runs each queued snippet in page order.
  - Before, every one of these scripts waited for DOMContentLoaded anyway
    (readyState was 'loading' when they were parsed), so their real work still starts
    at the same moment and in the same order, after assets/vitalsleep-product.js.
  - The code is split across vs-pdp-bundle.js and vs-pdp-bundle-2.js only for file size.
    Both register into window.__VSBR; the runner lives in this file.
  - Each snippet runs inside its own try/catch, like separate <script> tags did, so one
    error cannot stop the others.

  TO EDIT A SNIPPET'S BEHAVIOUR, edit its block below (search "=== vs-name ===").
  Settings that came from Liquid are read from __c["NAME"]; their Liquid source is in
  the stub inside snippets/vs-name.liquid.
  ROLLBACK: the live theme still has the old inline versions of every snippet.
*/
(function () {
  var R = window.__VSBR = window.__VSBR || {};

  /* ===================== === vs-quality-matters === ===================== */
  R["vs-quality-matters"] = function (__c) {
(function(){
  var SECTION_ID = __c["SECTION_ID"];
  var MODAL_ID = __c["MODAL_ID"];
  var tpl = document.getElementById('vs-qm-trigger-tpl-' + SECTION_ID);
  if(!tpl) return;

  /* Mirrors vsOpenModal / vsCloseModal in assets/vitalsleep-product.js.
     Duplicated here because that file's initModals() pass has already run by the
     time this trigger is injected, so the trigger would otherwise never be bound. */
  function openModal(){
    var backdrop = document.getElementById(MODAL_ID);
    if(!backdrop) return;
    backdrop.style.display = 'flex';
    backdrop.offsetHeight; /* force reflow so the transition fires */
    backdrop.classList.add('vs-modal-open');
    document.body.style.overflow = 'hidden';
    backdrop.dataset.active = '1';
    var card = backdrop.querySelector('.vs-modal-card');
    if(card){ card.setAttribute('tabindex','-1'); card.focus(); }
  }

  function closeModal(){
    var backdrop = document.getElementById(MODAL_ID);
    if(!backdrop) return;
    backdrop.classList.remove('vs-modal-open');
    backdrop.addEventListener('transitionend', function hide(){
      backdrop.style.display = 'none';
      backdrop.removeEventListener('transitionend', hide);
    });
    delete backdrop.dataset.active;
    if(!document.querySelectorAll('.vs-modal-backdrop[data-active]').length){
      document.body.style.overflow = '';
    }
  }

  /* data-vs-bound is the same flag initModals() checks, so whichever script gets
     there first wins and the other skips it. No double-binding either way. */
  function bindOpen(btn){
    if(!btn || btn.dataset.vsBound === '1') return;
    btn.dataset.vsBound = '1';
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });
  }

  function bindCloseFallbacks(){
    var backdrop = document.getElementById(MODAL_ID);
    if(!backdrop) return;
    var closers = backdrop.querySelectorAll('[data-close-modal]');
    for(var i = 0; i < closers.length; i++){
      if(closers[i].dataset.vsBound === '1') continue;
      closers[i].dataset.vsBound = '1';
      closers[i].addEventListener('click', function(e){
        e.stopPropagation();
        closeModal();
      });
    }
    if(backdrop.dataset.vsBound !== '1'){
      backdrop.dataset.vsBound = '1';
      backdrop.addEventListener('click', function(e){
        if(e.target === backdrop) closeModal();
      });
    }
  }

  function place(){
    var priceEls = document.querySelectorAll('#vs-pdp-' + SECTION_ID + ' .vs-price-box .vs-price-main');
    if(!priceEls.length) return false;

    for(var i = 0; i < priceEls.length; i++){
      var priceEl = priceEls[i];
      if(priceEl.parentNode && priceEl.parentNode.classList.contains('vs-price-row')) continue;

      var row = document.createElement('div');
      row.className = 'vs-price-row';
      priceEl.parentNode.insertBefore(row, priceEl);
      row.appendChild(priceEl);
      row.appendChild(tpl.content.cloneNode(true));
      bindOpen(row.querySelector('.vs-qm-trigger'));
    }

    /* Safety net: catch any trigger that exists but never got a handler. */
    var triggers = document.querySelectorAll('#vs-pdp-' + SECTION_ID + ' .vs-qm-trigger');
    for(var j = 0; j < triggers.length; j++) bindOpen(triggers[j]);

    bindCloseFallbacks();
    return true;
  }

  function boot(){
    if(place()) return;
    var tries = 0;
    var timer = setInterval(function(){
      tries++;
      if(place() || tries > 20) clearInterval(timer);
    }, 150);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
  };

  /* ===================== === vs-pdp-polish === ===================== */
  R["vs-pdp-polish"] = function (__c) {
(function(){
  if (window.__vsPdpPolishText) { return; }
  window.__vsPdpPolishText = true;

  function fixTimeline(){
    var rows = document.querySelectorAll('.vs-pdp .vs-timeline .vs-timeline-when');
    if (!rows.length) { return false; }
    var prevEnd = null;
    for (var i = 0; i < rows.length; i++){
      var raw = (rows[i].textContent || '').trim();
      var m = raw.match(/^(\D*?)(\d+)\s*[-‐-―]\s*(\d+)(\D*)$/);
      if (!m) { prevEnd = null; continue; }
      var lead = m[1], start = parseInt(m[2], 10), end = parseInt(m[3], 10), tail = m[4];
      if (prevEnd !== null && start <= prevEnd && prevEnd + 1 <= end){
        start = prevEnd + 1;
        rows[i].textContent = lead + start + '–' + end + tail;
      }
      prevEnd = end;
    }
    return true;
  }

  function hideRedundantPill(){
    var pills = document.querySelectorAll('.vs-pdp .vs-guarantee .vs-g-pill');
    if (!pills.length) { return false; }
    for (var i = 0; i < pills.length; i++){
      var t = (pills[i].textContent || '').toLowerCase();
      if (t.indexOf('60') !== -1 && t.indexOf('night') !== -1){
        pills[i].style.setProperty('display', 'none', 'important');
      }
    }
    return true;
  }

  var tries = 0;
  function run(){
    var a = fixTimeline();
    var b = hideRedundantPill();
    tries++;
    if ((!a || !b) && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();
  };

  /* ===================== === vs-pdp-design === ===================== */
  R["vs-pdp-design"] = function (__c) {
(function(){
  if (window.__vsPdpDesign) { return; }
  window.__vsPdpDesign = true;

  var TRUST = [
    { icon:'clock',    a:'60 Nights',  b:'to Decide',      note:'Not right for you? Full refund.' },
    { icon:'exchange', a:'Free Size',  b:'Exchange',       note:'Wrong size? We swap it free.' },
    { icon:'truck',    a:'Arrives in', b:'2–4 Days',   note:'Ships free from Florida.' },
    { icon:'shield',   a:'1-Year',     b:'Warranty',       note:'Free replacement, any reason.' }
  ];

  var VALUE_SUB     = 'Skip the expensive, inconvenient, and ongoing costs.';
  var SUPPORT_TITLE = 'You won’t figure it out alone.';
  var SUPPORT_BODY  = 'Step-by-step fitting instructions, adjustment guidance, and a US support team if you get stuck.';
  var SECURE_TEXT   = 'Secure checkout. Your information is safe.';

  var SVG = {
    clock: '<circle cx="12" cy="12" r="8.6" stroke="currentColor" stroke-width="1.8" fill="none"/><path d="M12 7.2V12l3.3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    exchange: '<path d="M4.5 9.5C6 6.4 9 4.5 12.3 4.5c2.9 0 5.5 1.4 7 3.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/><path d="M19.6 3.8v4.2h-4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M19.5 14.5C18 17.6 15 19.5 11.7 19.5c-2.9 0-5.5-1.4-7-3.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/><path d="M4.4 20.2V16h4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    truck: '<path d="M2.8 6.8h10.7v9.4H2.8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" fill="none"/><path d="M13.5 10h3.6l3.1 3v3.2h-6.7" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" fill="none"/><circle cx="6.4" cy="18.2" r="1.9" stroke="currentColor" stroke-width="1.8" fill="none"/><circle cx="16.8" cy="18.2" r="1.9" stroke="currentColor" stroke-width="1.8" fill="none"/>',
    shield: '<path d="M12 2.8l7 2.9v5.1c0 4.6-2.9 8.6-7 10.2-4.1-1.6-7-5.6-7-10.2V5.7l7-2.9z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" fill="none"/><path d="M8.8 12l2.3 2.3 4.2-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    lock: '<rect x="4.6" y="10.4" width="14.8" height="9.4" rx="2.2" stroke="currentColor" stroke-width="1.8" fill="none"/><path d="M8.2 10.2V7.6a3.8 3.8 0 0 1 7.6 0v2.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/>',
    headset: '<path d="M4.2 14.4v-2.2a7.8 7.8 0 0 1 15.6 0v2.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/><rect x="2.6" y="13.4" width="4.6" height="6.4" rx="2.3" stroke="currentColor" stroke-width="1.8" fill="none"/><rect x="16.8" y="13.4" width="4.6" height="6.4" rx="2.3" stroke="currentColor" stroke-width="1.8" fill="none"/>',
    cross: '<circle cx="10" cy="10" r="10" fill="#0970ce"/><path d="M7 7l6 6M13 7l-6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" fill="none"/>'
  };

  function svg(name){
    return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + SVG[name] + '</svg>';
  }

  function buildTrustRow(){
    var row = document.querySelector('.vs-pdp .vs-size-section .vs-cta-refund.vs-benefits-row');
    if (!row) { return false; }
    if (row.getAttribute('data-vsd') === '1') { return true; }
    var html = '';
    for (var i = 0; i < TRUST.length; i++){
      var t = TRUST[i];
      html += '<div class="vs-benefit-item">'
            +   '<span class="vs-benefit-icon" aria-hidden="true">' + svg(t.icon) + '</span>'
            +   '<span class="vs-benefit-text"><strong>' + t.a + '</strong><span>' + t.b + '</span></span>'
            +   '<span class="vsd-benefit-note">' + t.note + '</span>'
            + '</div>';
    }
    row.innerHTML = html;
    row.setAttribute('data-vsd', '1');
    return true;
  }

  function addSecureLine(){
    var pay = document.querySelector('.vs-pdp .vs-size-section .vs-pay-row');
    if (!pay || !pay.parentNode) { return false; }
    if (pay.parentNode.querySelector('.vsd-secure')) { return true; }
    var el = document.createElement('div');
    el.className = 'vsd-secure';
    el.innerHTML = svg('lock') + '<span>' + SECURE_TEXT + '</span>';
    pay.parentNode.insertBefore(el, pay.nextSibling);
    return true;
  }

  function addSupportPanel(){
    var card = document.querySelector('.vs-pdp .vs-info-col .vs-size-section');
    if (!card || !card.parentNode) { return false; }
    if (document.querySelector('.vs-pdp .vsd-support')) { return true; }
    var el = document.createElement('div');
    el.className = 'vsd-support';
    el.innerHTML = '<div class="vsd-support-head">'
                 +   '<span class="vsd-support-icon" aria-hidden="true">' + svg('headset') + '</span>'
                 +   '<span class="vsd-support-title">' + SUPPORT_TITLE + '</span>'
                 + '</div>'
                 + '<div class="vsd-support-body">' + SUPPORT_BODY + '</div>';
    card.parentNode.insertBefore(el, card.nextSibling);
    return true;
  }

  function styleValueList(){
    var list = document.querySelector('.vs-pdp .vs-value-list');
    if (!list) { return false; }
    var title = list.querySelector('.vs-value-list-title');
    if (title && title.parentNode && !list.querySelector('.vsd-value-sub')){
      var sub = document.createElement('div');
      sub.className = 'vsd-value-sub';
      sub.textContent = VALUE_SUB;
      title.parentNode.insertBefore(sub, title.nextSibling);
    }
    var items = list.querySelectorAll('.vs-price-compare-list li');
    for (var i = 0; i < items.length; i++){
      var txt = (items[i].textContent || '').trim().toLowerCase();
      var isCost = txt.indexOf('skip') === 0 || txt.indexOf('no ') === 0 || txt.indexOf('vs.') === 0;
      var mark = items[i].querySelector('.vs-feature-check');
      if (isCost && mark && mark.getAttribute('data-vsd') !== '1'){
        mark.innerHTML = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">' + SVG.cross + '</svg>';
        mark.setAttribute('data-vsd', '1');
      }
    }
    return true;
  }

  var tries = 0;
  function run(){
    var ok = buildTrustRow();
    ok = addSecureLine() && ok;
    ok = addSupportPanel() && ok;
    ok = styleValueList() && ok;
    tries++;
    if (!ok && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();
  };

  /* ===================== === vs-pdp-columns === ===================== */
  R["vs-pdp-columns"] = function (__c) {
(function(){
  if (window.__vsPdpColumns) { return; }
  window.__vsPdpColumns = true;

  
  var SELECTORS = ['.vs-value-list', '.vs-timeline'];
  var DESKTOP   = '(min-width: 768px)';

  var homes = [];
  var captured = false;

  function capture(){
    if (captured) { return true; }
    var info = document.querySelector('.vs-pdp .vs-info-col');
    var left = document.querySelector('.vs-pdp .vs-slider-col');
    if (!info || !left) { return false; }
    for (var i = 0; i < SELECTORS.length; i++){
      var el = info.querySelector(SELECTORS[i]);
      if (!el || !el.parentNode) { continue; }
      homes.push({ el: el, parent: el.parentNode, next: el.nextSibling });
    }
    captured = homes.length > 0;
    return captured;
  }

  function toLeft(){
    var left = document.querySelector('.vs-pdp .vs-slider-col');
    if (!left) { return; }
    var anchor = left.querySelector('.vs-accordion-section');
    for (var i = 0; i < homes.length; i++){
      var el = homes[i].el;
      if (el.parentNode === left) { continue; }
      el.classList.add('vsd-col-moved');
      if (anchor && anchor.parentNode === left){
        left.insertBefore(el, anchor);
      } else {
        left.appendChild(el);
      }
    }
  }

  
  function toRight(){
    for (var i = homes.length - 1; i >= 0; i--){
      var h = homes[i];
      if (h.el.parentNode === h.parent) { continue; }
      h.el.classList.remove('vsd-col-moved');
      if (h.next && h.next.parentNode === h.parent){
        h.parent.insertBefore(h.el, h.next);
      } else {
        h.parent.appendChild(h.el);
      }
    }
  }

  function apply(){
    if (!capture()) { return false; }
    if (window.matchMedia && window.matchMedia(DESKTOP).matches){
      toLeft();
    } else {
      toRight();
    }
    return true;
  }

  var tries = 0;
  function run(){
    tries++;
    if (!apply() && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1200);
  setTimeout(run, 2500);

  
  if (window.matchMedia){
    var mq = window.matchMedia(DESKTOP);
    if (mq.addEventListener){
      mq.addEventListener('change', apply);
    } else if (mq.addListener){
      mq.addListener(apply);
    }
  }

  var t = null;
  function debounced(){
    if (t) { clearTimeout(t); }
    t = setTimeout(apply, 150);
  }
  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);
})();
  };

  /* ===================== === vs-pdp-reviews === ===================== */
  R["vs-pdp-reviews"] = function (__c) {
(function () {
  var TOTAL = 3;
  var idx = 0;
  var wired = false;

  function isVisible(el) {
    if (!el) { return false; }
    if (el.offsetParent !== null) { return true; }
    var r = el.getBoundingClientRect();
    return (r.width > 0 && r.height > 0);
  }

  function visibleAccordion() {
    var all = document.querySelectorAll('.vs-accordion-section');
    for (var i = 0; i < all.length; i++) {
      if (isVisible(all[i])) { return all[i]; }
    }
    return null;
  }

  function paint() {
    var track = document.getElementById('vs-cr-track');
    if (track) { track.style.transform = 'translateX(-' + (idx * 100) + '%)'; }
    var dots = document.querySelectorAll('#vs-cr-dots .vs-cr-dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
  }

  function go(n) {
    idx = (n + TOTAL) % TOTAL;
    paint();
  }

  function wire() {
    if (wired) { return; }
    var prev = document.getElementById('vs-cr-prev');
    var next = document.getElementById('vs-cr-next');
    if (prev) { prev.addEventListener('click', function () { go(idx - 1); }); }
    if (next) { next.addEventListener('click', function () { go(idx + 1); }); }
    var dots = document.querySelectorAll('#vs-cr-dots .vs-cr-dot');
    for (var i = 0; i < dots.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () { go(parseInt(btn.getAttribute('data-i'), 10)); });
      })(dots[i]);
    }
    var vp = document.querySelector('.vs-cust-reviews .vs-cr-viewport');
    if (vp) {
      var x0 = null;
      vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(dx < 0 ? idx + 1 : idx - 1); }
        x0 = null;
      }, { passive: true });
    }
    wired = true;
  }

  function place() {
    var block = document.getElementById('vs-cust-reviews');
    if (!block) { return false; }
    var acc = visibleAccordion();
    if (!acc) { return false; }
    if (block.parentNode !== acc || acc.lastElementChild !== block) {
      acc.appendChild(block);
    }
    block.classList.add('vs-cr-placed');
    wire();
    paint();
    return true;
  }

  function boot() {
    place();
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (place() || tries > 24) { clearInterval(t); }
    }, 250);
    setTimeout(place, 1200);
    setTimeout(place, 2500);
  }

  var rt = null;
  function onResize() {
    if (rt) { clearTimeout(rt); }
    rt = setTimeout(place, 180);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-trust-bar === ===================== */
  R["vs-trust-bar"] = function (__c) {
(function(){
  if (window.__vsTrustBarClaimed) return;
  window.__vsTrustBarClaimed = true;

  var MATCH = 'icon_list';
  var bar = document.currentScript && document.currentScript.previousElementSibling;
  if (!bar || !bar.classList || !bar.classList.contains('vs-trustbar')) {
    bar = document.querySelector('.vs-trustbar');
  }
  if (!bar) return;

  var done = false, tries = 0;

  function findTarget(){
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      var s = (im.getAttribute('src') || '') + ' ' +
              (im.getAttribute('data-src') || '') + ' ' +
              (im.getAttribute('srcset') || '') + ' ' +
              (im.getAttribute('data-srcset') || '');
      if (s.indexOf(MATCH) !== -1) return im.closest('picture') || im;
    }
    var srcs = document.querySelectorAll('source');
    for (var j = 0; j < srcs.length; j++) {
      var ss = (srcs[j].getAttribute('srcset') || '') + ' ' +
               (srcs[j].getAttribute('data-srcset') || '');
      if (ss.indexOf(MATCH) !== -1) return srcs[j].closest('picture') || srcs[j].parentNode;
    }
    return null;
  }

  function place(){
    if (done) return true;
    var target = findTarget();
    if (!target || !target.parentNode) return false;
    target.parentNode.insertBefore(bar, target);
    target.style.setProperty('display', 'none', 'important');
    bar.classList.add('vs-tb-placed');
    done = true;
    return true;
  }

  function run(){
    if (place()) return;
    if (++tries > 24) return;
    setTimeout(run, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();
  };

  /* ===================== === vs-cro-fixes === ===================== */
  R["vs-cro-fixes"] = function (__c) {
(function(){
  if (window.__vsCroFixes) { return; }
  window.__vsCroFixes = true;

  /* ---------- 2. 60-Day -> 60-Night in visible text only ---------- */

  var SKIP = { SCRIPT:1, STYLE:1, NOSCRIPT:1, TEXTAREA:1, INPUT:1, SELECT:1, OPTION:1, CODE:1, PRE:1 };

  function fixDayText(root){
    if (!root) { return 0; }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var hits = 0;
    var node;
    while ((node = walker.nextNode())){
      var parent = node.parentNode;
      if (!parent || SKIP[parent.nodeName]) { continue; }
      var text = node.nodeValue;
      if (text.indexOf('60') === -1) { continue; }
      var next = text
        .replace(/60-Day/g,  '60-Night')
        .replace(/60-DAY/g,  '60-NIGHT')
        .replace(/60-day/g,  '60-night')
        .replace(/60 Day\b/g, '60 Night')
        .replace(/60 DAY\b/g, '60 NIGHT');
      if (next !== text){
        node.nodeValue = next;
        hits++;
      }
    }
    return hits;
  }

  /* ---------- 2b. "risk free" out of the FAQ button ---------- */

  function fixRiskFree(){
    var btns = document.querySelectorAll('.faq-section .faq-cta .faq-btn');
    for (var i = 0; i < btns.length; i++){
      var t = btns[i].textContent || '';
      if (/risk[\s-]*free/i.test(t)){
        btns[i].textContent = 'TRY IT FOR 60 NIGHTS';
      }
    }
  }

  /* ---------- 3. quiz link ---------- */

  var QUIZ_HEADING = /not\s+sure\s+which\s+size/i;
  var QUIZ_FALLBACK = '/pages/fit-quiz';

  function findQuizSection(){
    var heads = document.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < heads.length; i++){
      if (QUIZ_HEADING.test(heads[i].textContent || '')){
        return heads[i].closest('section, .shopify-section, div[id]') || heads[i];
      }
    }
    return null;
  }

  function stickyOffset(){
    var most = 0;
    var all = document.body.querySelectorAll('header, .shopify-section, div');
    for (var i = 0; i < all.length && i < 400; i++){
      var el = all[i];
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') { continue; }
      var r = el.getBoundingClientRect();
      if (r.top <= 2 && r.height > 20 && r.height < 220 && r.width > window.innerWidth * 0.6){
        if (r.height > most) { most = r.height; }
      }
    }
    return most + 12;
  }

  function track(name){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name });
    } catch (e) {}
  }

  function onQuizClick(ev){
    var target = findQuizSection();
    if (!target) { return; }
    ev.preventDefault();
    track('vs_buybox_quiz_click');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    if (y < 0) { y = 0; }
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  function addQuizLink(){
    var box = document.querySelector('.vs-pdp .vs-size-section');
    if (!box) { return false; }
    if (box.querySelector('.vs-quiz-link')) { return true; }

    var anchor = box.querySelector('.vs-size-options') || box.querySelector('.vs-size-btn');
    if (!anchor) { return false; }
    if (anchor.classList.contains('vs-size-btn')) { anchor = anchor.parentNode; }
    if (!anchor || !anchor.parentNode) { return false; }

    var a = document.createElement('a');
    a.className = 'vs-quiz-link';
    a.href = QUIZ_FALLBACK;
    a.setAttribute('data-vs-quiz', '1');
    a.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
      + '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>'
      + '<path d="M9.6 9.2a2.5 2.5 0 1 1 3.3 2.4c-.6.2-.9.7-.9 1.3v.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
      + '<circle cx="12" cy="16.6" r="1.1" fill="currentColor"/></svg>'
      + '<span>Not sure? Take the 10-second fit quiz</span>';
    a.addEventListener('click', onQuizClick);

    anchor.parentNode.insertBefore(a, anchor.nextSibling);
    return true;
  }

  /* ---------- boot ---------- */

  var tries = 0;
  function run(){
    tries++;
    fixDayText(document.body);
    fixRiskFree();
    var placed = addQuizLink();
    if (!placed && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1500);
  setTimeout(run, 3500);
  setTimeout(run, 6000);
})();
  };

  /* ===================== === vs-seo-collapse === ===================== */
  R["vs-seo-collapse"] = function (__c) {
(function(){
  if (window.__vsSeoCollapse) { return; }
  window.__vsSeoCollapse = true;

  /* ---------- 4. collapse the long SEO text block ---------- */


    var ROOT_HEADING = /what.{0,3}s\s+the\s+difference/i;
    var RENAME = [
      [/custom[\s-]*fit\s+snoring\s+mouthguard\s+for\s+adults/i,
       'How VitalSleep Differs From a Regular Mouthguard']
    ];

    function findRootHeading(){
      var heads = document.querySelectorAll('h2, h3');
      for (var i = 0; i < heads.length; i++){
        if (ROOT_HEADING.test(heads[i].textContent || '')) { return heads[i]; }
      }
      return null;
    }

    function renameHeadings(scope){
      var heads = scope.querySelectorAll('h1, h2, h3, h4');
      for (var i = 0; i < heads.length; i++){
        var t = heads[i].textContent || '';
        for (var r = 0; r < RENAME.length; r++){
          if (RENAME[r][0].test(t)){ heads[i].textContent = RENAME[r][1]; }
        }
      }
    }

    /* The heading we found may be wrapped several levels deep by the page
       builder. Climb until the element has a sibling that is, or contains,
       another heading. That element is the real row unit. */
    function rowUnitFor(head){
      var el = head;
      while (el && el.parentNode && el.parentNode.nodeType === 1){
        var parent = el.parentNode;
        var kids = parent.children;
        var withHeading = 0;
        for (var i = 0; i < kids.length; i++){
          if (kids[i].matches('h2, h3') || kids[i].querySelector('h2, h3')) { withHeading++; }
        }
        if (withHeading >= 2) { return { unit: el, parent: parent }; }
        el = parent;
        if (el === document.body) { break; }
      }
      return null;
    }

    function headingIn(el){
      if (el.matches && el.matches('h2, h3')) { return el; }
      return el.querySelector ? el.querySelector('h2, h3') : null;
    }

    function buildAccordion(){
      var head = findRootHeading();
      if (!head) { return 'no-heading'; }

      var found = rowUnitFor(head);
      if (!found) { return 'no-parent'; }

      var parent = found.parent;
      renameHeadings(parent);

      var kids = Array.prototype.slice.call(parent.children);
      var groups = [];
      var current = null;

      for (var i = 0; i < kids.length; i++){
        var h = headingIn(kids[i]);
        if (h){
          current = { title: (h.textContent || '').trim(), nodes: [kids[i]], heading: h };
          groups.push(current);
        } else if (current){
          current.nodes.push(kids[i]);
        }
      }

      if (groups.length < 2) { return 'too-few-groups'; }

      var wrap = document.createElement('div');
      wrap.className = 'vsacc';
      parent.insertBefore(wrap, groups[0].nodes[0]);

      for (var g = 0; g < groups.length; g++){
        var grp = groups[g];

        var row = document.createElement('div');
        row.className = 'vsacc-row';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vsacc-q';
        btn.setAttribute('aria-expanded', 'false');
        btn.innerHTML = '<span class="vsacc-t"></span><span class="vsacc-c" aria-hidden="true"></span>';
        btn.querySelector('.vsacc-t').textContent = grp.title;

        var panel = document.createElement('div');
        panel.className = 'vsacc-a';
        panel.hidden = true;

        /* the heading itself is now the button label, so drop it */
        if (grp.heading.parentNode === grp.nodes[0] || grp.heading === grp.nodes[0]){
          if (grp.heading === grp.nodes[0]){
            grp.nodes.shift();
          } else {
            grp.heading.parentNode.removeChild(grp.heading);
          }
        } else if (grp.heading.parentNode){
          grp.heading.parentNode.removeChild(grp.heading);
        }

        for (var n = 0; n < grp.nodes.length; n++){ panel.appendChild(grp.nodes[n]); }

        row.appendChild(btn);
        row.appendChild(panel);
        wrap.appendChild(row);

        (function(b, p, r){
          b.addEventListener('click', function(){
            var open = b.getAttribute('aria-expanded') === 'true';
            b.setAttribute('aria-expanded', open ? 'false' : 'true');
            p.hidden = open;
            r.className = open ? 'vsacc-row' : 'vsacc-row is-open';
          });
        })(btn, panel, row);
      }

      return 'ok:' + groups.length;
    }

  var tries = 0;
  var done = false;
  function run(){
    tries++;
    if (!done){
      var r = buildAccordion();
      if (r && r.indexOf('ok:') === 0) { done = true; }
    }
    if (!done && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1500);
  setTimeout(run, 3500);
  setTimeout(run, 6000);
})();
  };

  /* ===================== === vs-size-guide-link === ===================== */
  R["vs-size-guide-link"] = function (__c) {
(function(){
  if (window.__vsSizeGuideLink) { return; }
  window.__vsSizeGuideLink = true;


  var LABEL   = /^\s*size\s*guide\s*$/i;
  var POP_SEL = '[role="dialog"], .vs-sg, [class*="modal"], [class*="popup"], [class*="lightbox"], [class*="drawer"]';

  var ICO = '<svg class="vs-sglink__ico vs-sgfix__ico" width="17" height="17" viewBox="0 0 24 24"'
    + ' fill="none" aria-hidden="true" focusable="false">'
    + '<rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" stroke-width="2"/>'
    + '<path d="M7 7v3M12 7v4M17 7v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
    + '</svg>';

  function inPopup(el){
    /* ancestors only. Element.closest() tests the element itself first, and
       this store's own triggers carry class="vs-modal-trigger", so a
       self-inclusive test silently skips the real trigger. */
    return !!(el.parentElement && el.parentElement.closest(POP_SEL));
  }

  function candidates(){
    var scope = document.querySelector('.vs-pdp');
    if (!scope) { return []; }
    var nodes = scope.querySelectorAll('button, a, span, div');
    var out = [];
    for (var i = 0; i < nodes.length; i++){
      var el = nodes[i];
      if (el.querySelector('button, a')) { continue; }
      if (!LABEL.test(el.textContent || '')) { continue; }
      if (inPopup(el)) { continue; }
      out.push(el);
    }
    /* keep only the innermost matches, so a wrapper div and the button
       inside it do not both get styled */
    var keep = [];
    for (var a = 0; a < out.length; a++){
      var nested = false;
      for (var b = 0; b < out.length; b++){
        if (a !== b && out[a].contains(out[b])) { nested = true; break; }
      }
      if (!nested) { keep.push(out[a]); }
    }
    return keep;
  }

  function decorate(){
    var els = candidates();
    if (!els.length) { return 'none'; }
    var done = 0;
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      if (el.getAttribute('data-vs-sgfix') === '1') { done++; continue; }

      var text = (el.textContent || '').trim();
      el.classList.add('vs-sglink');
      el.classList.add('vs-sgfix');
      el.innerHTML = ICO + '<span class="vs-sglink__t vs-sgfix__t"></span>';
      el.querySelector('.vs-sgfix__t').textContent = text;
      el.setAttribute('data-vs-sgfix', '1');
      done++;
    }
    return 'ok:' + done;
  }

  var tries = 0;
  function run(){
    tries++;
    var r = decorate();
    if (r === 'none' && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1500);
  setTimeout(run, 3500);
  setTimeout(run, 6000);
})();
  };

  /* ===================== === vs-14-nights === ===================== */
  R["vs-14-nights"] = function (__c) {
(function () {
  if (window.__vs14Nights) {
    return;
  }
  window.__vs14Nights = true;

  var TRIGGER_TEXT = __c["TRIGGER_TEXT"];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  var overlay = null;
  var lastTrigger = null;
  var savedOverflow = '';
  var savedPaddingRight = '';
  var locked = false;

  function track(name) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: name });
      }
    } catch (e) {}
  }

  /* ---------- one dialog only, moved to <body> ---------- */

  function collect() {
    var all = document.querySelectorAll('[data-vs-14-modal]');
    if (!all.length) {
      return null;
    }
    for (var i = 1; i < all.length; i++) {
      if (all[i].parentNode) {
        all[i].parentNode.removeChild(all[i]);
      }
    }
    var node = all[0];
    if (node.parentNode !== document.body) {
      document.body.appendChild(node);
    }
    return node;
  }

  /* ---------- scroll lock ---------- */

  function otherDialogOpen() {
    var open = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < open.length; i++) {
      var el = open[i];
      if (overlay && (el === overlay || overlay.contains(el))) {
        continue;
      }
      if (el.offsetParent !== null || el.getClientRects().length) {
        return true;
      }
    }
    return false;
  }

  function lock() {
    if (locked) {
      return;
    }
    var bar = window.innerWidth - document.documentElement.clientWidth;
    savedOverflow = document.body.style.overflow;
    savedPaddingRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    if (bar > 0) {
      document.body.style.paddingRight = bar + 'px';
    }
    locked = true;
  }

  function unlock() {
    if (!locked) {
      return;
    }
    locked = false;
    if (otherDialogOpen()) {
      return;
    }
    document.body.style.overflow = savedOverflow;
    document.body.style.paddingRight = savedPaddingRight;
  }

  /* ---------- open / close ---------- */

  function open(trigger) {
    overlay = collect();
    if (!overlay) {
      return;
    }
    lastTrigger = trigger || null;
    overlay.hidden = false;
    lock();
    void overlay.offsetWidth;
    overlay.classList.add('vs-14-in');
    var scroll = overlay.querySelector('[data-vs-14-scroll]');
    if (scroll) {
      scroll.scrollTop = 0;
    }
    var closeBtn = overlay.querySelector('[data-vs-14-close]');
    if (closeBtn) {
      closeBtn.focus();
    }
    track('vitalsleep_14_night_plan_opened');
  }

  function finish() {
    if (!overlay) {
      return;
    }
    overlay.hidden = true;
    unlock();
    if (lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function close(reason) {
    if (!overlay || overlay.hidden) {
      return;
    }
    track(reason === 'cta' ? 'vitalsleep_14_night_plan_cta_clicked' : 'vitalsleep_14_night_plan_closed');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    overlay.classList.remove('vs-14-in');
    if (reduce) {
      finish();
    } else {
      window.setTimeout(finish, 180);
    }
  }

  /* ---------- focus trap ---------- */

  function trap(ev) {
    if (!overlay || overlay.hidden) {
      return;
    }
    var items = overlay.querySelectorAll(FOCUSABLE);
    var list = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent !== null || items[i].getClientRects().length) {
        list.push(items[i]);
      }
    }
    if (!list.length) {
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', function (ev) {
    if (!overlay || overlay.hidden) {
      return;
    }
    if (ev.key === 'Escape' || ev.key === 'Esc') {
      ev.stopPropagation();
      close('esc');
    } else if (ev.key === 'Tab') {
      trap(ev);
    }
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) {
      return;
    }
    if (t.closest('[data-vs-14-open]')) {
      ev.preventDefault();
      open(t.closest('[data-vs-14-open]'));
      return;
    }
    if (t.closest('[data-vs-14-cta]')) {
      ev.preventDefault();
      close('cta');
      return;
    }
    if (t.closest('[data-vs-14-close]')) {
      ev.preventDefault();
      close('x');
      return;
    }
    if (overlay && !overlay.hidden && t.closest('[data-vs-14-modal]') && !t.closest('.vs-14-dialog')) {
      close('backdrop');
    }
  });

  /* ---------- trigger injection, under the size buttons ---------- */

  function buildTrigger() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vs-14-trigger';
    b.setAttribute('data-vs-14-open', '1');
    b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
      + '<rect x="3.2" y="4.6" width="17.6" height="16.2" rx="2.4" stroke="currentColor" stroke-width="2"/>'
      + '<path d="M3.2 9.6h17.6M8 2.8v3.6M16 2.8v3.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
      + '</svg><span class="vs-14-label"></span><span class="vs-14-arrow" aria-hidden="true">→</span>';
    var label = b.querySelector('.vs-14-label');
    if (label) {
      label.textContent = TRIGGER_TEXT;
    }
    return b;
  }

  function addTrigger() {
    if (document.querySelector('.vs-14-trigger')) {
      return true;
    }

    var box = document.querySelector('.vs-pdp .vs-size-section') || document.querySelector('.vs-size-section');
    var anchor = null;

    if (box) {
      anchor = box.querySelector('.vs-quiz-link')
        || box.querySelector('.vs-size-options')
        || box.querySelector('.vs-size-btn');
      if (anchor && anchor.classList.contains('vs-size-btn')) {
        anchor = anchor.parentNode;
      }
    }

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(buildTrigger(), anchor.nextSibling);
      return true;
    }

    /* fallback: immediately above the first real Add to Cart button */
    var atc = document.querySelector('.vs-pdp button[name="add"], .vs-pdp .vs-atc, form[action*="/cart/add"] button[name="add"]');
    if (atc && atc.parentNode && !atc.parentElement.closest('.vs-sticky-atc, .sticky-atc, [class*="sticky"]')) {
      atc.parentNode.insertBefore(buildTrigger(), atc);
      return true;
    }

    return false;
  }

  /* ---------- boot ---------- */

  var tries = 0;
  function run() {
    tries++;
    collect();
    var placed = addTrigger();
    if (!placed && tries < 24) {
      window.setTimeout(run, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.setTimeout(run, 1500);
  window.setTimeout(run, 3500);
  window.setTimeout(run, 6000);
})();
  };

  /* ===================== === vs-quiz-modal === ===================== */
  R["vs-quiz-modal"] = function (__c) {
(function(){
  if (window.__vsQuizModal) { return; }
  window.__vsQuizModal = true;

  var CATCH_ALL = __c["CATCH_ALL"];
  var CTA_PREFIX = __c["CTA_PREFIX"];

  var root, panel, opened = null, lastFocus = null;
  var answers = { sex:null, height:null, jaw:null };
  var result  = null;

  /* ---------- helpers ---------- */

  function track(name){
    if (!window.dataLayer) { return; }
    try { window.dataLayer.push({ event: name }); } catch (e) {}
  }

  function q(sel, ctx){ return (ctx || root).querySelector(sel); }
  function all(sel, ctx){ return (ctx || root).querySelectorAll(sel); }

  /* ---------- the rules, same as /pages/fit-quiz ---------- */

  function recommend(a){
    if (a.sex === 'male'){
      if (a.height === 'short' && a.jaw === 'small'){
        return {
          size: "Women's",
          why: "You are on the shorter side with a smaller jaw, so the Women's tray usually seats better than the Men's."
        };
      }
      return {
        size: "Men's",
        why: "The Men's size is the wider tray and it is the right starting point for most men."
      };
    }
    if (a.height === 'tall' && a.jaw === 'avg'){
      return {
        size: "Men's",
        why: "You are taller with an average or larger jaw, so the wider Men's tray tends to fit better than the Women's."
      };
    }
    return {
      size: "Women's",
      why: "The Women's size is the slightly smaller tray and it is the right starting point for most women."
    };
  }

  /* ---------- buy box ---------- */

  function sizeButtons(){
    var box = document.querySelector('.vs-pdp .vs-size-section')
           || document.querySelector('.vs-pdp .vs-size-options')
           || document.querySelector('.vs-pdp');
    if (!box) { return []; }
    var list = box.querySelectorAll('.vs-size-btn, .vs-size-options button, .vs-size-options label');
    return list && list.length ? list : [];
  }

  /*
    "Men" is a substring of "Women", so WOMEN IS TESTED FIRST and a
    men match is only accepted once women has been ruled out. Getting
    this the other way round selects the wrong size every time.
  */
  function selectSize(size){
    var wantWomen = /women/i.test(size);
    var btns = sizeButtons();
    for (var i = 0; i < btns.length; i++){
      var t = (btns[i].textContent || '').toLowerCase();
      var isWomen = t.indexOf('women') !== -1;
      var isMen   = !isWomen && t.indexOf('men') !== -1;
      if ((wantWomen && isWomen) || (!wantWomen && isMen)){
        try { btns[i].click(); } catch (e) {}
        return btns[i];
      }
    }
    return null;
  }

  function revealBuyBox(){
    var box = document.querySelector('.vs-pdp .vs-size-section')
           || document.querySelector('.vs-pdp .vs-size-options');
    if (!box || !box.getBoundingClientRect) { return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var r = box.getBoundingClientRect();
    if (r.top > 60 && r.bottom < window.innerHeight) { return; }
    var y = r.top + window.pageYOffset - 110;
    if (y < 0) { y = 0; }
    try {
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, y);
    }
  }

  /* ---------- scroll lock, shared with the other dialogs ---------- */

  var prevOverflow = '', prevPad = '';

  function lock(){
    prevOverflow = document.body.style.overflow;
    prevPad = document.body.style.paddingRight;
    var gap = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (gap > 0) { document.body.style.paddingRight = gap + 'px'; }
  }

  /*
    Never release a lock another dialog still needs. The size guide and
    the First 14 Nights dialog both use aria-modal, so if one of those
    is open the body stays locked.
  */
  function unlock(){
    var others = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < others.length; i++){
      var el = others[i];
      if (panel && el === panel) { continue; }
      if (el.offsetParent !== null || el.getClientRects().length){ return; }
    }
    document.body.style.overflow = prevOverflow;
    document.body.style.paddingRight = prevPad;
  }

  /* ---------- open and close ---------- */

  /*
    The trigger element is passed in rather than read from
    document.activeElement: Safari does not focus a link on click, so
    activeElement is usually <body> and focus would be returned to the
    top of the page on close.
  */
  function open(trigger){
    if (!root || !root.hasAttribute('hidden')) { return; }
    lastFocus = trigger || document.activeElement;
    root.removeAttribute('hidden');
    lock();
    opened = true;
    track('vitalsleep_fit_quiz_opened');
    var first = q('[data-vsqz-res]').hasAttribute('hidden')
      ? q('.vs-qz__opt')
      : q('[data-vsqz-cta]');
    if (first && first.focus) { try { first.focus(); } catch (e) {} }
  }

  function close(){
    if (!root || root.hasAttribute('hidden')) { return; }
    root.setAttribute('hidden', '');
    unlock();
    opened = false;
    track('vitalsleep_fit_quiz_closed');
    if (lastFocus && lastFocus.focus){ try { lastFocus.focus(); } catch (e) {} }
  }

  function trapFocus(ev){
    if (ev.key !== 'Tab' || !opened) { return; }
    var f = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < f.length; i++){
      if (f[i].offsetParent !== null || f[i].getClientRects().length) { list.push(f[i]); }
    }
    if (!list.length) { return; }
    var first = list[0], last = list[list.length - 1];
    if (ev.shiftKey && document.activeElement === first){
      ev.preventDefault(); last.focus();
    } else if (!ev.shiftKey && document.activeElement === last){
      ev.preventDefault(); first.focus();
    }
  }

  /* ---------- quiz interaction ---------- */

  function markDone(key){
    var block = q('[data-vsqz-q="' + key + '"]');
    if (block) { block.classList.add('is-done'); }
  }

  function onOpt(btn){
    var block = btn.closest('[data-vsqz-q]');
    if (!block) { return; }
    var key = block.getAttribute('data-vsqz-q');
    var sibs = all('.vs-qz__opt', block);
    for (var i = 0; i < sibs.length; i++){ sibs[i].setAttribute('aria-pressed', 'false'); }
    btn.setAttribute('aria-pressed', 'true');
    answers[key] = btn.getAttribute('data-vsqz-val');
    markDone(key);
    q('[data-vsqz-err]').setAttribute('hidden', '');
  }

  function show(){
    if (!answers.sex || !answers.height || !answers.jaw){
      q('[data-vsqz-err]').removeAttribute('hidden');
      return;
    }
    result = recommend(answers);
    q('[data-vsqz-size]').textContent = result.size;
    q('[data-vsqz-why]').textContent = result.why;
    q('[data-vsqz-cta]').textContent = CTA_PREFIX + ' ' + result.size + ' size';
    q('.vs-qz__form').setAttribute('hidden', '');
    q('[data-vsqz-res]').removeAttribute('hidden');
    track('vitalsleep_fit_quiz_result');
    var cta = q('[data-vsqz-cta]');
    if (cta && cta.focus){ try { cta.focus(); } catch (e) {} }
  }

  function reset(){
    answers = { sex:null, height:null, jaw:null };
    result = null;
    var opts = all('.vs-qz__opt');
    for (var i = 0; i < opts.length; i++){ opts[i].setAttribute('aria-pressed', 'false'); }
    var blocks = all('[data-vsqz-q]');
    for (var j = 0; j < blocks.length; j++){ blocks[j].classList.remove('is-done'); }
    q('[data-vsqz-err]').setAttribute('hidden', '');
    q('[data-vsqz-res]').setAttribute('hidden', '');
    q('.vs-qz__form').removeAttribute('hidden');
  }

  function takeSize(){
    if (!result) { return; }
    selectSize(result.size);
    track('vitalsleep_fit_quiz_size_taken');
    close();
    revealBuyBox();
  }

  /* ---------- taking the click off the existing links ---------- */

  function isTrigger(el){
    if (!el || !el.closest) { return null; }
    var hit = el.closest('.vs-quiz-link, [data-vs-quiz]');
    if (hit) { return hit; }
    if (!CATCH_ALL) { return null; }
    var a = el.closest('a[href]');
    if (!a) { return null; }
    var href = a.getAttribute('href') || '';
    if (/\/pages\/fit-quiz(\?|#|$)/i.test(href)) { return a; }
    return null;
  }

  function onDocClick(ev){
    if (ev.defaultPrevented) { return; }
    if (ev.button && ev.button !== 0) { return; }
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) { return; }
    var hit = isTrigger(ev.target);
    if (!hit) { return; }
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) { ev.stopImmediatePropagation(); }
    open(hit);
  }

  /* ---------- boot ---------- */

  function boot(){
    root = document.getElementById('vs-qz-root');
    if (!root) { return false; }
    panel = root.querySelector('.vs-qz__panel');
    if (!panel) { return false; }

    /*
      Moved to <body> so a transformed or overflow-hidden ancestor in
      the buy box cannot clip a position:fixed overlay, and so the
      buttons are never inside the product form.
    */
    if (root.parentNode !== document.body){ document.body.appendChild(root); }

    root.addEventListener('click', function(ev){
      var t = ev.target;
      if (t.closest('[data-vsqz-close]')) { ev.preventDefault(); close(); return; }
      if (t.closest('[data-vsqz-go]'))    { ev.preventDefault(); show(); return; }
      if (t.closest('[data-vsqz-again]')) { ev.preventDefault(); reset(); return; }
      if (t.closest('[data-vsqz-cta]'))   { ev.preventDefault(); takeSize(); return; }
      var opt = t.closest('.vs-qz__opt');
      if (opt) { ev.preventDefault(); onOpt(opt); }
    });

    document.addEventListener('keydown', function(ev){
      if (!opened) { return; }
      if (ev.key === 'Escape' || ev.key === 'Esc') { close(); return; }
      trapFocus(ev);
    });

    document.addEventListener('click', onDocClick, true);
    return true;
  }

  var tries = 0;
  function run(){
    tries++;
    if (!boot() && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
  };

  /* ===================== === vs-buybox-order === ===================== */
  R["vs-buybox-order"] = function (__c) {
(function(){
  if (window.__vsBuyBoxOrder) { return; }
  window.__vsBuyBoxOrder = true;

  var DO_GUARANTEE = __c["DO_GUARANTEE"];
  var DO_EXCHANGE = __c["DO_EXCHANGE"];
  var DO_ALIGN = __c["DO_ALIGN"];
  var DO_14 = __c["DO_14"];
  var DO_STOCK = __c["DO_STOCK"];
  var DO_SHOPPAY = __c["DO_SHOPPAY"];
  var DO_HOW = __c["DO_HOW"];
  var DO_PAY = __c["DO_PAY"];
  var GREY_PAY = __c["GREY_PAY"];
  var HOW_LABEL = __c["HOW_LABEL"];
  /* off by default: hiding one of four tiles leaves an odd grid, so
     this is a look-at-it-first decision, not a safe default */
  var DO_TILES = __c["DO_TILES"];

  var busy = false;

  /* ---------- finding things by what they say ---------- */

  function inDialog(el){
    return !!(el.closest && el.closest('[aria-modal], dialog, .vs-qz, .qm, .ulb'));
  }

  /*
    Returns the DEEPEST elements whose text matches, so a match on a
    wrapper does not shadow the paragraph inside it. Skips anything
    living inside a lightbox.
  */
  function byText(re, scope){
    var root = scope || document.body;
    if (!root) { return []; }
    var out = [];
    var all = root.querySelectorAll('p, span, div, li, a, button, small, strong, b, em, i, label, h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (!re.test(el.textContent || '')) { continue; }
      if (inDialog(el)) { continue; }
      var deeper = false;
      for (var j = 0; j < el.children.length; j++){
        if (re.test(el.children[j].textContent || '')) { deeper = true; break; }
      }
      if (!deeper) { out.push(el); }
    }
    return out;
  }

  function sizeSection(){
    return document.querySelector('.vs-pdp .vs-size-section')
        || document.querySelector('.vs-pdp .vs-size-options');
  }

  /*
    THE SIZE BUTTONS, not .vs-size-section. On desktop that section
    wrapper stretches from the price down past the delivery lines, so
    it is useless as a position marker. The buttons are not.
  */
  function sizeAnchor(){
    var el = document.querySelector('.vs-pdp .vs-size-options');
    if (el) { return el; }
    var btn = document.querySelector('.vs-pdp .vs-size-btn');
    if (btn && btn.parentNode) { return btn.parentNode; }
    return document.querySelector('.vs-size-options');
  }

  /* The "Choose Your Size" heading, so blocks land ABOVE it, not
     between the heading and the buttons. */
  function topAnchor(){
    var hits = byText(/^\s*choose\s+your\s+size\s*$/i, document.querySelector('.vs-pdp'));
    return hits.length ? hits[0] : sizeAnchor();
  }

  /* Smallest container holding BOTH the size buttons and the button,
     i.e. the buy box column that everything is stacked in. */
  function column(){
    var a = sizeAnchor(), atc = atcButton();
    if (!a || !atc) { return null; }
    var n = a.parentNode;
    while (n && n.nodeType === 1 && !n.contains(atc)) { n = n.parentNode; }
    return (n && n.nodeType === 1) ? n : null;
  }

  /* The direct child of the column that holds el, which is the thing
     that actually has to be reordered. */
  function rowIn(col, el){
    if (!col || !el) { return null; }
    var n = el;
    while (n && n.parentNode && n.parentNode !== col) { n = n.parentNode; }
    return (n && n.parentNode === col) ? n : null;
  }

  /*
    The smallest wrapper that carries essentially just this element's
    text, so a link is moved with its "2 min read" tail but never with
    half the buy box. Stops at anything holding the size buttons or the
    Add to Cart button.
  */
  function tightRow(el){
    var node = el;
    for (var i = 0; i < 2; i++){
      var up = node.parentNode;
      if (!up || up.nodeType !== 1) { break; }
      if (up.querySelector('.vs-size-options, .vs-size-btn, button[name="add"]')) { break; }
      var a = (up.textContent || '').trim().length;
      var b = (node.textContent || '').trim().length;
      if (a - b > 40) { break; }
      node = up;
    }
    return node;
  }

  function atcButton(){
    var b = document.querySelector('.vs-pdp button[name="add"], .vs-pdp .vs-cta-btn, .vs-pdp #btnCTA')
         || document.querySelector('button[name="add"]');
    if (b) { return b; }
    var hits = byText(/add\s+vitalsleep\s+to\s+cart/i, document.querySelector('.vs-pdp') || document.body);
    for (var i = 0; i < hits.length; i++){
      var c = hits[i].closest('button, a');
      if (c) { return c; }
    }
    return null;
  }

  /*
    VISUAL position, not DOM position. This buy box is a flex column
    with explicit `order` values on phones (see vs-pdp-columns), so the
    order an element appears in is NOT the order it sits in the DOM.
    Every position test below therefore measures the screen.
  */
  function topOf(el){
    if (!el || !el.getBoundingClientRect) { return null; }
    var r = el.getBoundingClientRect();
    if (!r || (!r.height && !r.width)) { return null; }
    return r.top + (window.pageYOffset || 0);
  }

  /*
    A DOM move alone does nothing inside a flex container that assigns
    `order`, so a moved block is given the SAME order value as the
    element it now sits before. Equal order falls back to DOM order,
    which is what the move just set.
  */
  function orderOf(el){
    if (!el || !window.getComputedStyle) { return null; }
    var n = parseInt(window.getComputedStyle(el).order, 10);
    return (isNaN(n) || n === 0) ? null : n;
  }

  function matchOrder(el, ref){
    if (!el || !ref || el.parentNode !== ref.parentNode) { return; }
    var n = orderOf(ref);
    if (n !== null) { el.style.order = n; }
  }

  function before(el, ref){
    if (!el || !ref || !ref.parentNode) { return false; }
    if (el.nextSibling === ref && el.parentNode === ref.parentNode) { return true; }
    ref.parentNode.insertBefore(el, ref);
    return true;
  }

  function after(el, ref){
    if (!el || !ref || !ref.parentNode) { return false; }
    if (ref.nextSibling === el) { return true; }
    ref.parentNode.insertBefore(el, ref.nextSibling);
    return true;
  }

  /* ---------- 1. duplicate 60-night line under the price ---------- */

  function fixGuarantee(){
    var size = topAnchor();
    if (!size) { return; }
    var top = topOf(size);
    if (top === null) { return; }
    var RE = /60[-\s]?night\s+money[-\s]?back\s+guarantee/i;
    var hits = byText(RE, document.querySelector('.vs-pdp'));
    if (!hits.length) { hits = byText(RE, document.body); }
    for (var i = 0; i < hits.length; i++){
      var el = hits[i];
      if (el.getAttribute('data-vs-bb') === 'guarantee') { continue; }
      /* never touch the button's own subline or the trust tile */
      if (el.closest('button, a')) { continue; }
      var t = topOf(el);
      if (t === null || t >= top) { continue; }
      el.setAttribute('data-vs-bb', 'guarantee');
      el.style.display = 'none';
    }
  }

  /* ---------- 2. the blue "Not sure? Free size exchanges" line ---------- */

  function fixExchange(){
    var hits = byText(/not\s*sure[^.]{0,20}free\s+size\s+exchange/i, document.querySelector('.vs-pdp'));
    for (var i = 0; i < hits.length; i++){
      var el = hits[i];
      if (el.getAttribute('data-vs-bb') === 'exchange') { continue; }
      el.setAttribute('data-vs-bb', 'exchange');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var n;
      while ((n = walker.nextNode())){
        if (/not\s*sure/i.test(n.nodeValue)){
          n.nodeValue = n.nodeValue.replace(/not\s*sure\?\s*/i, '');
        }
      }
      el.classList.add('vs-bb-plain');
      /*
        The deepest text match is usually a <span> inside the row, so
        the icon beside it would stay blue. The row itself is greyed
        too when it carries no other copy.
      */
      var row = el.parentNode;
      if (row && row.nodeType === 1 &&
          (row.textContent || '').trim() === (el.textContent || '').trim()){
        row.classList.add('vs-bb-plain');
      }
    }
  }

  /* ---------- 3. Size Guide row alignment ---------- */

  function fixAlign(){
    var link = document.querySelector('.vs-pdp .vs-sgfix, .vs-pdp .vs-sglink');
    if (!link) {
      var hits = byText(/^\s*size\s+guide\s*$/i, document.querySelector('.vs-pdp'));
      link = hits.length ? hits[0] : null;
    }
    if (!link) { return; }
    /*
      The centring often sits on a wrapper, not on the link's immediate
      parent, so up to two ancestors are left-aligned. The walk stops
      before any container that also holds the size buttons or the Add
      to Cart button, so the whole buy box is never re-aligned.
    */
    var row = link.parentNode;
    for (var n = 0; n < 2 && row && row.nodeType === 1; n++){
      if (row.querySelector('.vs-size-options, .vs-size-btn, button[name="add"]')) { break; }
      if (!row.classList.contains('vs-bb-left')){
        row.setAttribute('data-vs-bb', 'align');
        row.classList.add('vs-bb-left');
      }
      row = row.parentNode;
    }
  }

  /* ---------- 4. First 14 Nights below the button ---------- */

  function fourteenTriggers(){
    var scope = document.querySelector('.vs-pdp') || document.body;
    var hits = byText(/first\s+14\s+nights/i, scope);
    var out = [];
    for (var i = 0; i < hits.length; i++){
      var t = hits[i].closest('button, a') || hits[i];
      if (inDialog(t)) { continue; }
      if (out.indexOf(t) === -1) { out.push(t); }
    }
    return out;
  }

  function move14(){
    var trig = fourteenTriggers();
    if (!trig.length) { return; }
    /*
      vs-14-nights re-runs on its own timers. If it ever inserts a
      second trigger, the extra is removed rather than left to sit in
      the buy box next to the one that has already moved.
    */
    var el = trig[0];
    for (var k = 0; k < trig.length; k++){
      if (trig[k].getAttribute('data-vs-bb') === '14nights'){ el = trig[k]; break; }
    }
    for (var i = 0; i < trig.length; i++){
      if (trig[i] !== el && trig[i].parentNode) { trig[i].parentNode.removeChild(trig[i]); }
    }
    var col = column(), atc = atcButton();
    if (!col || !atc) { return; }
    var atcRow = rowIn(col, atc);
    if (!atcRow || atcRow.contains(el)) { return; }
    el.classList.add('vs-bb-below');
    el.setAttribute('data-vs-bb', '14nights');
    if (el.parentNode !== atcRow.parentNode){ after(el, atcRow); }
  }

  /* ---------- 4b. the snoring explainer link ---------- */

  /*
    THE PAGE CARRIES TWO OF THESE, one in the intro and one below the
    button, almost certainly a pair of breakpoint variants that the
    theme hides with a descendant rule. Moving one out of its wrapper
    escapes that rule and both become visible, which is exactly what
    happened. So: keep ONE, remove the rest, and prefer a copy that is
    actually visible at this width over one the theme has hidden.

    Matches the old wording AND the new label, so it still finds the
    link after the first pass has renamed it.
  */
  var HOW_RE = /how\s+snoring\s+actually\s+works|why\s+you\s+snore/i;

  function howCandidates(){
    var hits = byText(HOW_RE, document.querySelector('.vs-pdp'));
    var out = [];
    for (var i = 0; i < hits.length; i++){
      var link = hits[i].closest('a') || hits[i];
      if (inDialog(link)) { continue; }
      var row = tightRow(link);
      var seen = false;
      for (var j = 0; j < out.length; j++){
        if (out[j].row === row || out[j].link === link) { seen = true; break; }
      }
      if (!seen) { out.push({ row: row, link: link }); }
    }
    return out;
  }

  function relabelHow(link){
    if (!link || !HOW_LABEL) { return; }
    var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())){
      if (/how\s+snoring\s+actually\s+works/i.test(n.nodeValue)){
        n.nodeValue = n.nodeValue.replace(/how\s+snoring\s+actually\s+works/i, HOW_LABEL);
      }
    }
  }

  function moveHow(){
    var rows = howCandidates();
    if (!rows.length) { return; }
    var col = column(), atc = atcButton();
    if (!col || !atc) { return; }
    var atcRow = rowIn(col, atc);
    if (!atcRow) { return; }

    var keep = null, i;
    for (i = 0; i < rows.length; i++){
      if (rows[i].row.getAttribute('data-vs-bb') === 'how'){ keep = rows[i]; break; }
    }
    if (!keep){
      for (i = 0; i < rows.length; i++){
        if (topOf(rows[i].row) !== null){ keep = rows[i]; break; }
      }
    }
    if (!keep) { keep = rows[0]; }

    for (i = 0; i < rows.length; i++){
      var r = rows[i].row;
      if (r === keep.row) { continue; }
      if (r.contains(atcRow) || r === atcRow || r.contains(keep.row)) { continue; }
      if (r.querySelector('.vs-size-options, .vs-size-btn, button[name="add"]')) { continue; }
      if (r.parentNode) { r.parentNode.removeChild(r); }
    }

    if (keep.row.contains(atcRow) || keep.row === atcRow) { return; }
    relabelHow(keep.link);
    keep.row.classList.add('vs-bb-below');
    keep.row.setAttribute('data-vs-bb', 'how');
    /* placement is stackBelow's job, so the order below the button is
       decided in one place instead of by whichever step ran last */
    if (keep.row.parentNode !== atcRow.parentNode){ after(keep.row, atcRow); }
  }

  /* ---------- 4d. secure checkout line and the card icons ---------- */

  function secureRow(){
    var hits = byText(/secure\s+checkout/i, document.querySelector('.vs-pdp'));
    if (!hits.length) { return null; }
    var el = hits[0];
    if (inDialog(el) || el.closest('button')) { return null; }
    return tightRow(el);
  }

  /*
    The icon row has no text to match on, so it is found by the card
    logos themselves and then by climbing to the SMALLEST ancestor
    holding at least three of them. Fails closed if fewer than three
    are on the page, which means it never grabs a lone Shop Pay badge.
  */
  function payRow(){
    var scope = document.querySelector('.vs-pdp');
    if (!scope) { return null; }
    var names = ['visa', 'mastercard', 'american express', 'amex', 'discover',
                 'paypal', 'shop pay', 'shop_pay', 'google pay', 'google_pay',
                 'apple pay', 'apple_pay', 'diners'];
    var sel = [];
    for (var i = 0; i < names.length; i++){
      sel.push('img[alt*="' + names[i] + '" i]');
      sel.push('img[src*="' + names[i].replace(/ /g, '_') + '" i]');
    }
    var icons = scope.querySelectorAll(sel.join(','));
    if (icons.length < 3) { return null; }
    var node = icons[0].parentNode;
    while (node && node !== scope && node.nodeType === 1){
      var count = 0;
      for (var j = 0; j < icons.length; j++){
        if (node.contains(icons[j])) { count++; }
      }
      if (count >= 3) { break; }
      node = node.parentNode;
    }
    if (!node || node === scope || node.nodeType !== 1) { return null; }
    if (node.querySelector('.vs-size-options, button[name="add"]')) { return null; }
    return node;
  }

  function tilesRow(){
    var hits = byText(/60\s*nights\s*to\s*decide/i, document.querySelector('.vs-pdp'));
    if (!hits.length) { return null; }
    var tile = hits[0].closest('div, li');
    if (!tile) { return null; }
    /* the grid, not the one tile */
    var up = tile.parentNode;
    if (up && up.nodeType === 1 && up.children.length >= 2 &&
        !up.querySelector('.vs-size-options, button[name="add"]')){
      return up;
    }
    return tile;
  }

  /*
    ONE ordering pass for everything below the button, so the pieces
    cannot fight each other. Reassurance first, because it answers
    "is this safe to click" and belongs at the click. Then the tiles,
    which are about what happens after the purchase. Then the two
    reads, which are browsing material and must never sit between a
    shopper and the checkout.
  */
  function stackBelow(atcRow, col){
    var seq = [];
    if (DO_PAY)  { seq.push(secureRow(), payRow()); }
    seq.push(tilesRow());
    if (DO_HOW)  { seq.push(document.querySelector('.vs-pdp [data-vs-bb="how"]')); }
    if (DO_14)   { seq.push(document.querySelector('.vs-pdp [data-vs-bb="14nights"]')); }

    var ref = atcRow, seen = [];
    for (var i = 0; i < seq.length; i++){
      var el = seq[i];
      if (!el || el === atcRow || el.contains(atcRow)) { continue; }
      if (seen.indexOf(el) !== -1) { continue; }
      if (el.contains(ref)) { continue; }
      seen.push(el);
      after(el, ref);
      matchOrder(el, ref);
      ref = el;
    }
  }

  function markPay(){
    if (!DO_PAY) { return; }
    var sec = secureRow(), pay = payRow();
    if (sec) { sec.classList.add('vs-bb-secure'); sec.setAttribute('data-vs-bb', 'secure'); }
    if (pay && pay !== sec){
      pay.setAttribute('data-vs-bb', 'pay');
      if (GREY_PAY) { pay.classList.add('vs-bb-pay'); }
    }
  }

  /* ---------- 4c. trust tiles that now repeat the delivery line ---------- */

  function trimTiles(){
    var hits = byText(/arrives\s+in\s+2[-–\s]*4\s+days/i, document.querySelector('.vs-pdp'));
    for (var i = 0; i < hits.length; i++){
      var tile = hits[i].closest('div, li');
      if (!tile || tile.querySelector('.vs-size-options, button[name="add"]')) { continue; }
      if (tile.getAttribute('data-vs-bb') === 'tile') { continue; }
      tile.setAttribute('data-vs-bb', 'tile');
      tile.style.display = 'none';
    }
  }

  /* ---------- 5. stock and delivery up to the price ---------- */

  function stockBlock(){
    var scope = document.querySelector('.vs-pdp');
    if (!scope) { return null; }
    var hits = byText(/estimated\s+delivery/i, scope);
    if (!hits.length) { return null; }
    var el = hits[0];
    var node = el;
    for (var up = 0; up < 4; up++){
      if (!node.parentNode || node.parentNode === scope) { break; }
      node = node.parentNode;
      if (/in\s+stock/i.test(node.textContent || '') && !/add\s+vitalsleep/i.test(node.textContent || '')){
        return node;
      }
    }
    return el.parentNode && /in\s+stock/i.test(el.parentNode.textContent || '') ? el.parentNode : el;
  }

  /*
    Target is the column child that holds the "Choose Your Size"
    heading, so the block lands above the heading rather than between
    the heading and the buttons.
  */
  function placeTarget(){
    var col = column(), anchor = topAnchor();
    if (!col || !anchor) { return null; }
    return { col: col, row: rowIn(col, anchor) };
  }

  function moveStock(){
    var t = placeTarget();
    var block = stockBlock();
    if (!t || !t.row || !block) { return; }
    if (block.contains(t.row) || block === t.row || block.contains(t.col)) { return; }
    block.classList.add('vs-bb-stock');
    block.setAttribute('data-vs-bb', 'stock');
    before(block, t.row);
    matchOrder(block, t.row);
  }

  /* ---------- 6. Shop Pay, moved only if the theme renders it ---------- */

  function moveShopPay(){
    var el = document.querySelector('shopify-payment-terms, .shopify-payment-terms, [data-shopify="payment-terms"]');
    var t = placeTarget();
    if (!el || !t || !t.row) { return; }
    if (inDialog(el) || el.contains(t.row)) { return; }
    el.setAttribute('data-vs-bb', 'shoppay');
    before(el, t.row);
    matchOrder(el, t.row);
  }

  /* ---------- run ---------- */

  var timer = null;

  /*
    A mutation that lands WHILE a pass is running must not be dropped:
    it is rescheduled instead of skipped. Without this, a block moved
    back by another snippet during our own pass would never be
    corrected until the next fixed timer.
  */
  function schedule(ms){
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(apply, ms);
  }

  function apply(){
    if (busy) { schedule(120); return; }
    busy = true;
    try {
      if (DO_GUARANTEE) { fixGuarantee(); }
      if (DO_EXCHANGE)  { fixExchange(); }
      if (DO_ALIGN)     { fixAlign(); }
      if (DO_SHOPPAY)   { moveShopPay(); }
      if (DO_STOCK)     { moveStock(); }
      if (DO_HOW)       { moveHow(); }
      if (DO_14)        { move14(); }
      if (DO_TILES)     { trimTiles(); }
      markPay();
      var _col = column(), _atc = atcButton();
      if (_col && _atc){
        var _row = rowIn(_col, _atc);
        if (_row) { stackBelow(_row, _col); }
      }
    } catch (e) {}
    setTimeout(function(){ busy = false; }, 60);
  }

  function boot(){
    if (!sizeSection()) { return false; }
    apply();
    var box = document.querySelector('.vs-pdp');
    if (box && window.MutationObserver){
      var mo = new MutationObserver(function(){ schedule(200); });
      mo.observe(box, { childList: true, subtree: true });
    }
    return true;
  }

  var tries = 0;
  function run(){
    tries++;
    if (!boot() && tries < 24){ setTimeout(run, 250); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(apply, 1500);
  setTimeout(apply, 3500);
  setTimeout(apply, 6000);
})();
  };

  /* ===================== === vs-hiw-wide === ===================== */
  R["vs-hiw-wide"] = function (__c) {
(function(){
  if (window.__vsHiwWide) { return; }
  window.__vsHiwWide = true;

  var HEADING = __c["HEADING"];
  var SELECTOR = __c["SELECTOR"];
  var TWO_COL = __c["TWO_COL"];
  var LABEL = __c["LABEL"];
  var DURATION = __c["DURATION"];
  var TYPE = __c["TYPE"];
  var PLAYBTN = __c["PLAYBTN"];
  var PAUSEOFF = __c["PAUSEOFF"];
  var UNMUTE = __c["UNMUTE"];

  var busy = false, timer = null;

  function esc(s){ return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var RE = new RegExp(esc(HEADING).replace(/\s+/g, '\\s+'), 'i');

  function visible(el){
    if (!el || !el.getBoundingClientRect) { return false; }
    var r = el.getBoundingClientRect();
    return !!(r.width && r.height);
  }

  function pos(el){
    if (!el || !window.getComputedStyle) { return ''; }
    return window.getComputedStyle(el).position || '';
  }

  /* deepest elements whose text matches, so a wrapper never shadows
     the heading inside it */
  function byText(re){
    var all = document.body.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div, strong, b');
    var out = [];
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (!re.test(el.textContent || '')) { continue; }
      var deeper = false;
      for (var j = 0; j < el.children.length; j++){
        if (re.test(el.children[j].textContent || '')) { deeper = true; break; }
      }
      if (!deeper) { out.push(el); }
    }
    return out;
  }

  /*
    Climb from the heading. The first ancestor that is position:fixed
    is the overlay; the element just below it is the panel, which is
    what actually needs the width. This works whatever the popup's
    classes are, which matters because they are GemPages-generated and
    can change without warning.
  */
  function findPanel(){
    if (SELECTOR){
      var pinned = document.querySelector(SELECTOR);
      if (pinned && visible(pinned)) { return pinned; }
    }
    var hits = byText(RE);
    for (var i = 0; i < hits.length; i++){
      var node = hits[i];
      if (!visible(node)) { continue; }
      /* never restyle our own dialogs */
      if (node.closest('.vs-qz, .qm')) { continue; }
      var last = node, up = node.parentNode;
      for (var n = 0; n < 10 && up && up.nodeType === 1 && up !== document.body; n++){
        if (pos(up) === 'fixed') { return last; }
        last = up;
        up = up.parentNode;
      }
      var dlg = node.closest('[role="dialog"], [aria-modal], dialog, .modal, .ulb');
      if (dlg){
        var kid = dlg.firstElementChild;
        return (kid && kid.contains(node)) ? kid : dlg;
      }
    }
    return null;
  }

  /* the panel's own header strip, i.e. the child holding the heading */
  function headStrip(panel){
    var hits = byText(RE);
    for (var i = 0; i < hits.length; i++){
      var h = hits[i];
      if (!panel.contains(h)) { continue; }
      var node = h;
      while (node && node.parentNode && node.parentNode !== panel){ node = node.parentNode; }
      if (node && node.parentNode === panel) { return node; }
    }
    return null;
  }

  /*
    The scrolling body: the panel child that is not the header and
    carries the bulk of the content.
  */
  function bodyStrip(panel, head){
    var best = null, bestLen = 0;
    for (var i = 0; i < panel.children.length; i++){
      var c = panel.children[i];
      if (c === head) { continue; }
      var len = (c.textContent || '').length;
      if (len > bestLen){ bestLen = len; best = c; }
    }
    return bestLen > 200 ? best : null;
  }

  /*
    The "How it Works" line under the header. Restyled as an eyebrow
    and relabelled. The video's REAL duration is read off the <video>
    element rather than typed in, so it cannot go stale when the clip
    is replaced.
  */
  function fmt(sec){
    if (!sec || !isFinite(sec) || sec < 1) { return ''; }
    var m = Math.floor(sec / 60), s2 = Math.round(sec % 60);
    if (s2 === 60) { m += 1; s2 = 0; }
    return m + ':' + (s2 < 10 ? '0' : '') + s2;
  }

  function labelRow(panel){
    var all = panel.querySelectorAll('p, span, div, h1, h2, h3, h4, h5, h6, strong, b');
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (!/^\s*how\s+it\s+works\s*$/i.test(el.textContent || '')) { continue; }
      if (el.closest('button, a')) { continue; }
      if (el.children.length) { continue; }
      return el;
    }
    return null;
  }

  function setLabel(panel){
    var el = labelRow(panel);
    if (!el) { return; }
    if (!el.classList.contains('vs-hiw-eyebrow')){
      el.classList.add('vs-hiw-eyebrow');
      if (LABEL) { el.textContent = LABEL; }
      el.setAttribute('data-vs-hiw', 'label');
    }
    if (!DURATION) { return; }
    var v = panel.querySelector('video');
    if (!v) { return; }
    var base = el.getAttribute('data-vs-hiw-base') || el.textContent;
    el.setAttribute('data-vs-hiw-base', base);
    function stampIt(){
      var d = fmt(v.duration);
      if (d) { el.textContent = base + '  ·  ' + d; }
    }
    if (v.readyState >= 1) { stampIt(); }
    else { v.addEventListener('loadedmetadata', stampIt, false); }
  }

  /* ---------- the video ---------- */

  /*
    FOUR GUARDS, and every one of them earns its place:
      1. IntersectionObserver, for scrolling the video out of the panel
      2. Escape, which closes the popup without a click
      3. any click on a close control or on the backdrop
      4. a poll that runs ONLY while playing, for the case the popup is
         DESTROYED on close. A detached <video> keeps playing its audio
         with no events left to listen for, so the poll checks
         document.contains() and gives up as soon as it pauses.
  */
  function guardVideo(v, panel){
    if (v.__vsGuarded) { return; }
    v.__vsGuarded = true;

    function pause(){
      try { if (!v.paused) { v.pause(); } } catch (e) {}
    }

    /*
      Close controls are labelled every which way. Attributes first,
      then the visible text, because plenty of them are just an X with
      nothing else on the element.
    */
    function isClose(t){
      var el = t.closest('[aria-label*="close" i], [title*="close" i], [class*="close" i], [data-close]');
      if (el) { return true; }
      var btn = t.closest('button, a');
      if (!btn) { return false; }
      return /^\s*(close|x|×|✕|✖|❌)\s*$/i.test(btn.textContent || '');
    }

    if (window.IntersectionObserver){
      try {
        new IntersectionObserver(function(entries){
          for (var i = 0; i < entries.length; i++){
            if (entries[i].intersectionRatio < 0.35) { pause(); }
          }
        }, { threshold: [0, 0.35, 0.75] }).observe(v);
      } catch (e) {}
    }

    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' || ev.key === 'Esc') { pause(); }
    }, false);

    document.addEventListener('click', function(ev){
      if (v.paused) { return; }
      var t = ev.target;
      if (!t || !t.closest) { return; }
      if (t.closest('.vs-hiw-play')) { return; }
      var inside = panel && panel.contains(t);
      if (inside && !isClose(t)) { return; }
      setTimeout(pause, 40);
    }, true);

    var poll = null;
    v.addEventListener('play', function(){
      if (poll) { clearInterval(poll); }
      poll = setInterval(function(){
        if (!document.contains(v) || !visible(v)){
          pause();
          clearInterval(poll);
          poll = null;
        }
      }, 700);
    }, false);
    v.addEventListener('pause', function(){
      if (poll) { clearInterval(poll); poll = null; }
    }, false);
  }

  /*
    The native control is a small square in the corner, which reads as
    a file rather than an invitation. This adds a large centred button
    and hides it while the clip runs. The native controls are left in
    place so pause and scrub still work.
  */
  function addPlayButton(v){
    if (v.__vsPlayBtn || !v.parentNode) { return; }
    v.__vsPlayBtn = true;

    var wrap = document.createElement('div');
    wrap.className = 'vs-hiw-vwrap';
    v.parentNode.insertBefore(wrap, v);
    wrap.appendChild(v);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vs-hiw-play';
    btn.setAttribute('aria-label', 'Play video');
    btn.innerHTML = '<span class="vs-hiw-play__i" aria-hidden="true"></span>';
    wrap.appendChild(btn);

    btn.addEventListener('click', function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      /* a deliberate press means they want to hear it */
      if (UNMUTE) { try { v.muted = false; } catch (e) {} }
      try {
        var p = v.play();
        if (p && p.catch) { p.catch(function(){}); }
      } catch (e) {}
    }, false);

    function on(){ wrap.classList.add('is-playing'); }
    function off(){ wrap.classList.remove('is-playing'); }
    v.addEventListener('play', on, false);
    v.addEventListener('playing', on, false);
    v.addEventListener('pause', off, false);
    v.addEventListener('ended', off, false);
    if (!v.paused) { on(); }
  }

  function setupVideo(panel){
    var v = panel.querySelector('video');
    if (!v) { return; }
    if (!v.hasAttribute('playsinline')) { v.setAttribute('playsinline', ''); }
    if (PLAYBTN)  { addPlayButton(v); }
    if (PAUSEOFF) { guardVideo(v, panel); }
  }

  /*
    A paragraph counts as a headline ONLY when the bold run is the
    whole paragraph. A bold phrase inside a sentence stays inline,
    which is the difference between

      The gap between working and not working is about a millimeter.

    and the same sentence broken into three stacked fragments.
  */
  function promote(body){
    var ps = body.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++){
      var p = ps[i];
      if (p.classList.contains('vs-hiw-h')) { continue; }
      if (p.children.length !== 1) { continue; }
      var kid = p.children[0];
      var tag = (kid.tagName || '').toLowerCase();
      if (tag !== 'strong' && tag !== 'b') { continue; }
      var whole = (p.textContent || '').trim();
      var bold  = (kid.textContent || '').trim();
      if (!bold || whole !== bold) { continue; }
      if (bold.length > 90) { continue; }
      p.classList.add('vs-hiw-h');
    }
  }

  function apply(){
    if (busy) { return; }
    busy = true;
    try {
      var panel = findPanel();
      if (panel){
        var head = headStrip(panel);
        var body = bodyStrip(panel, head) || panel;
        if (!panel.classList.contains('vs-hiw-panel')){
          panel.classList.add('vs-hiw-panel');
          if (head && head !== panel){ head.classList.add('vs-hiw-head'); }
          if (TYPE) { body.classList.add('vs-hiw-body'); }
          if (TWO_COL && body !== panel) { body.classList.add('vs-hiw-two'); }
        }
        if (TYPE) { promote(body); }
        setupVideo(panel);
        setLabel(panel);
      }
    } catch (e) {}
    busy = false;
  }

  function schedule(){
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(apply, 120);
  }

  /*
    The popup is usually built or revealed only when the button is
    clicked, so the first pass runs after that click. The click is NOT
    intercepted: no preventDefault, no stopPropagation, so the popup's
    own handler runs exactly as before.
  */
  function onClick(ev){
    var t = ev.target;
    if (!t || !t.closest) { return; }
    var hit = t.closest('a, button, [role="button"]');
    if (!hit) { return; }
    if (!/how\s+it\s+works/i.test(hit.textContent || '')) { return; }
    setTimeout(apply, 60);
    setTimeout(apply, 300);
    setTimeout(apply, 900);
    arm(5000);
  }

  /* 15-Sep-2026 speed: the page watcher used to run forever and re-ran apply()
     on every change anywhere on the page (reviews, carousels). It now watches
     for 8s after load and for 5s after each How It Works click, then stops. */
  var mo = null, watching = false, offTimer = null;
  function arm(ms){
    if (!mo) { return; }
    if (!watching){ mo.observe(document.body, { childList: true, subtree: true }); watching = true; }
    if (offTimer) { clearTimeout(offTimer); }
    offTimer = setTimeout(function(){ mo.disconnect(); watching = false; }, ms);
  }

  function boot(){
    document.addEventListener('click', onClick, false);
    if (window.MutationObserver){
      mo = new MutationObserver(schedule);
      arm(8000);
    }
    apply();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  function run() {
    var q = window.__VSB || [];
    while (q.length) {
      var item = q.shift();
      var fn = item && R[item[0]];
      if (!fn) { continue; }
      try { fn(item[1] || {}); }
      catch (e) { if (window.console) { console.warn('[vs-pdp-bundle] ' + item[0] + ' failed', e); } }
    }
  }
  window.__VSBRUN = run;
  /* Theme editor re-renders a section without a new page load: run any new stubs. */
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 0); });
})();
